import { headerConstants } from "../_constants";

export const pageDashboard = () => ({
  type: headerConstants.PAGE_DASHBOARD
});

export const pageNotes = () => ({
  type: headerConstants.PAGE_NOTES
});

export const pageAlerts = () => ({
  type: headerConstants.PAGE_ALERTS
});

export const pageDevices = () => ({
  type: headerConstants.PAGE_DEVICES
});

export const pageReports = () => ({
  type: headerConstants.PAGE_REPORTS
});



// WEBPACK FOOTER //
// ./src/_actions/header.actions.js